

/* custom-engraving.js
   - UpCart controls ATC; we hook click (capture) to add add-ons
   - Prevents UpCart/theme from reacting to our widget input changes
   - Adds engraving/gift/message + wooden gift box add-ons ONCE per ATC click
*/

(function () {
  // ✅ Prevent double-install if file is included twice
  if (window.__customEngravingGiftInstalled) {
    console.warn("[custom-engraving] Already installed. Skipping duplicate init.");
    return;
  }
  window.__customEngravingGiftInstalled = true;

  // -----------------------------
  // STATE / DEDUPE
  // -----------------------------
  let inFlight = false;
  let lastSig = "";
  let lastSigAt = 0;

  function inWidget(el) {
    return !!(el && el.closest && el.closest(".gs__form-options-wrapper"));
  }

  function buildSignature() {
    const engrave_id = (jQuery("#engraving-product-id").val() || "").trim();
    const gift_id = (jQuery("#engraving-gift-product-id").val() || "").trim();
    const box_id = (jQuery("#wodden-gift-product-id").val() || "").trim(); // keep your id as-is

    const l1 = (jQuery("#engravingInput1").val() || "").trim();
    const l2 = (jQuery("#engravingInput2").val() || "").trim();
    const gm = (jQuery("#gs-product-gift-msg").val() || "").trim();

    return [engrave_id, gift_id, box_id, l1, l2, gm].join("|");
  }

  // -----------------------------
  // ENGRAVING CHECKBOX (CAPTURE)
  // -----------------------------
  document.addEventListener(
    "change",
    function (e) {
      const el = e.target;
      if (!el || !el.matches(".gs__oneclick-variant")) return;
      if (!inWidget(el)) return;

      if (el.checked) {
        document.querySelectorAll(".gs__oneclick-variant").forEach((cb) => {
          if (cb !== el) cb.checked = false;
        });

        jQuery(".engraving-custom-text-box").show();

        if (el.classList.contains("engraving-logo-option")) {
          jQuery(".engrave-logo-box").show();
        } else {
          jQuery(".engrave-logo-box").hide();
        }

        jQuery("#engraving-product-id").val(el.value);
      } else {
        jQuery(".engraving-custom-text-box").hide();
        jQuery(".engrave-logo-box").hide();
        jQuery("#engraving-product-id").val("");
      }

      e.stopImmediatePropagation(); // block UpCart/theme
    },
    true
  );

  // -----------------------------
  // GIFT MESSAGE PRODUCT CHECKBOX (CAPTURE)
  // -----------------------------
  document.addEventListener(
    "change",
    function (e) {
      const el = e.target;
      if (!el || !el.matches(".gs__product-element-gift")) return;
      if (!inWidget(el)) return;

      if (el.checked) {
        document.querySelectorAll(".gs__product-element-gift").forEach((cb) => {
          if (cb !== el) cb.checked = false;
        });

        jQuery(".gift-message-box").show();
        jQuery("#engraving-gift-product-id").val(el.value);
      } else {
        jQuery(".gift-message-box").hide();
        jQuery("#engraving-gift-product-id").val("");
      }

      e.stopImmediatePropagation(); // block UpCart/theme
    },
    true
  );

  // -----------------------------
  // WOODEN GIFT BOX CHECKBOX (CAPTURE)
  // -----------------------------
  document.addEventListener(
    "change",
    function (e) {
      const el = e.target;
      if (!el || !el.matches(".gs__product-element-gift-box")) return;
      if (!inWidget(el)) return;

      // Single checkbox -> just set/unset hidden id
      if (el.checked) {
        jQuery("#wodden-gift-product-id").val(el.value);
      } else {
        jQuery("#wodden-gift-product-id").val("");
      }

      e.stopImmediatePropagation(); // block UpCart/theme
    },
    true
  );

  // -----------------------------
  // ADD ITEMS (JSON)
  // -----------------------------
  function addItems(items) {
    return jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ items })
    });
  }

  // -----------------------------
  // HOOK ADD-TO-CART CLICK (CAPTURE)
  // -----------------------------
  document.addEventListener(
    "click",
    function (e) {
      const btn =
        e.target && e.target.closest
          ? e.target.closest(
              'button[type="submit"], input[type="submit"], button[name="add"], [data-add-to-cart]'
            )
          : null;

      if (!btn) return;

      // Guard: only run for actual product add-to-cart forms
      const form = btn.closest && btn.closest('form[action^="/cart/add"]');
      if (!form) return;

      const engrave_id = (jQuery("#engraving-product-id").val() || "").trim();
      const gift_id = (jQuery("#engraving-gift-product-id").val() || "").trim();
      const box_id = (jQuery("#wodden-gift-product-id").val() || "").trim();

      // No add-ons selected -> do nothing
      if (!engrave_id && !gift_id && !box_id) return;

      // Dedupe: same signature within 2 seconds -> ignore
      const sig = buildSignature();
      const now = Date.now();

      if (inFlight) return;
      if (sig && sig === lastSig && now - lastSigAt < 2000) return;

      lastSig = sig;
      lastSigAt = now;
      inFlight = true;

      const engrave_msg_1 = (jQuery("#engravingInput1").val() || "").trim();
      const engrave_msg_2 = (jQuery("#engravingInput2").val() || "").trim();
      const gift_msg = (jQuery("#gs-product-gift-msg").val() || "").trim();

      const items = [];

      // Engraving add-on (with properties)
      if (engrave_id) {
        const v = parseInt(engrave_id, 10);
        if (v) {
          items.push({
            id: v,
            quantity: 1,
            properties: { "Line 1": engrave_msg_1, "Line 2": engrave_msg_2 }
          });
        }
      }

      // Gift message product (with properties)
      if (gift_id) {
        const v = parseInt(gift_id, 10);
        if (v) {
          items.push({
            id: v,
            quantity: 1,
            properties: { "Textarea 2": gift_msg }
          });
        }
      }

      // Wooden gift box (NO properties)
      if (box_id) {
        const v = parseInt(box_id, 10);
        if (v) {
          items.push({
            id: v,
            quantity: 1
          });
        }
      }

      if (!items.length) {
        inFlight = false;
        return;
      }

      setTimeout(function() { 
      // Do NOT preventDefault — UpCart must add main product
        addItems(items)
          .always(function () {
            inFlight = false;
          })
          .fail(function (xhr) {
            console.error("Add-ons add failed:", xhr.responseText || xhr);
          });
      }, 1500);
    },
    true
  );
})();
